import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "@components/Layout";
import PageLoader from "@components/Loader/Loader";
import Login from "@pages/Login";
import Dashboard from "@pages/Dashboard";
import CredentialNew from "@pages/CredentialNew";
import CredentialDetail from "@pages/CredentialDetail";
import CredentialEdit from "@pages/CredentialEdit";
import SharedCredentialPage from "@pages/SharedCredential/SharedCredential";
import RequestsDashboard from "@pages/RequestsDashboard/RequestsDashboard";
import ValidationDashboard from "@pages/ValidationDashboard/ValidationDashboard";
import NotFound from "@pages/NotFound";

const RoutesComponent = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Shared credential — public, no auth, no app Layout */}
        <Route path="/shared/:token" element={<SharedCredentialPage />} />

        {/* All other routes use the app Layout */}
        <Route path="*" element={
          <Layout>
            <Routes>
              {/* Public Route */}
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/credentials/new"
                element={
                  <ProtectedRoute>
                    <CredentialNew />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/credentials/:id"
                element={
                  <ProtectedRoute>
                    <CredentialDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/credentials/:id/edit"
                element={
                  <ProtectedRoute>
                    <CredentialEdit />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/requests"
                element={
                  <ProtectedRoute>
                    <RequestsDashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/validation"
                element={
                  <ProtectedRoute>
                    <ValidationDashboard />
                  </ProtectedRoute>
                }
              />

              {/* 404 Not Found */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
